import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit{
  services: any = [];
  language!:string;
  selectedId = 1;
  selectedFile = "software-services";
  selectedService: any = [];
  formattedHtml!: string; // To store the formatted HTML  
  config: any;
  selectedProject: string = "";
  selectedServiceType: string = "";

  constructor(
    private fetchDataService: FetchDataService,
    private router: Router,
    private route: ActivatedRoute    
  ) {}

  onIdChange(): void {        
    this.services.forEach((element:any, index:number) => {                        
      this.selectedService[index] = element.services.find((item:any)=> item.id === this.selectedId);                            
      if (this.selectedService[index]) {      
        this.selectedService.htmlContent = this.formatHtml(this.selectedService[index].htmlContent);
      }
    });

    
  }
  onProjectChange() {
    // Automatically select the first service type when a project is selected or changed
    if (this.selectedProject && this.config.projects[this.selectedProject].service_types) {
      this.selectedServiceType = this.config.projects[this.selectedProject].service_types[0];
    }
  }

  loadNewData(): void {
    this.getJSONServices();
  }

  updateHtmlCode(){
    this.selectedService.htmlContent = this.formattedHtml;
  }



  ngOnInit(): void {    
    this.fetchDataService.getConfigFile().subscribe((config:any) => {      
      this.config = config;            
      this.selectedProject = Object.keys(config.projects)[0];
    });
    this.getJSONServices();    
  }

  updateJsonData(id:number,lang:string,data:any){
    console.log("Update data");
    
    this.fetchDataService.updateJsonData(
      this.selectedProject,this.selectedFile,this.selectedServiceType,id,lang,data
    ).subscribe((data:any) => {
      console.log(data);      
    });
  }
  
  getJSONServices(){          
      this.fetchDataService.getJSONServicesByFileName(this.selectedProject,this.selectedFile,this.selectedServiceType).subscribe({
        next: (data: any) => {                    
          this.services = data;                    
          this.onIdChange();
                              
        },
        error: (err) => {
          console.error('Error fetching services:', err);
        },
      });
    
  }
  
  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  formatHtml(html: string): string {
    let formatted = html.replace(/<\//g, '\n</')
                        .replace(/>\s*</g, '>\n<')
                        .replace(/([^\n])<span/g, '$1\n<span')
                        .replace(/>\s*([^<]+)\s*</g, '> $1 <');

    // Adding indentation
    let indent = '';
    const lines = formatted.split('\n');
    formatted = lines.map(line => {
      if (line.match(/<\/.*?>/)) {
        indent = indent.substring(2);
      }
      const result = indent + line;
      if (line.match(/<[^\/!].*?>/)) {
        indent += '  ';
      }
      return result;
    }).join('\n');
    return formatted;
  }

  logData(): void {
    if (this.selectedService) {
      // Create a deep copy of selectedService to manipulate for logging
      const loggedService = JSON.parse(JSON.stringify(this.selectedService));

      // Clean htmlContent within the copy
      loggedService.htmlContent = loggedService.htmlContent.replace(/(\r\n|\n|\r)/gm, "").replace(/\s+/g, " ");
      
      const formattedJson = JSON.stringify(loggedService, null, 2);
       // Copy the formatted JSON to the clipboard
    navigator.clipboard.writeText(formattedJson).then(() => {
      console.log("JSON data copied to clipboard!");
    }).catch(err => {
      console.error("Failed to copy JSON data: ", err);
    });
    }
  }
  

}
